import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { listaCurso, getListaTalleres, listaNivel, crearTaller, editarTaller, listaProfesores, eliminarTaller } from "../../../service/CongifCursoHorario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import classNames from "classnames";
import { isNotVacioNull, isNumerico, isLetrasEspacio, minMax, isValue, getResultValidar } from "../../../utilities/Validate";
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../../utilities/Seguridad";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { getLista } from "../../../service/FichaEstudiante";
import { PickList } from "primereact/picklist";

export const PageElectivo = () => {
    const dispatch = useDispatch();

    const [globalFilter, setGlobalFilter] = useState("");
    const toast = useRef(null);
    const toastBL = useRef(null);

    const [tablaData, setTablaData] = useState([]);

    const [profesionales, setProfesionales] = useState([]);
    const [alumnos, setAlumnos] = useState([]);
    const [niveles, setNiveles] = useState([]);
    const [valueNivel, setValueNivel] = useState({});
    const [cursos, setCursos] = useState([]);
    const [valueCurso, setValueCurso] = useState({});
    const [cursosFilter, setCursosFilter] = useState([]);
    const [visibleRight, setVisibleRight] = useState(false);
    const [visibleRightA, setVisibleRightA] = useState(false);
    const [dataFicha, setDataFicha] = useState(null);

    const [selectedProfesionales, setSelectedProfesionales] = useState([]);
    const [selectedNiveles, setSelectedNiveles] = useState([]);
    const dataEdit = useRef({});
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const labelDialog = useRef({ title: "", labelButton: "", editAcceso: {}, visible: false, es_nuevo: false });

    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    let claseTaller = {
        id: "",
        nombre: "",
        idNivel: "",
        nivel: "",
    };

    let claseTallerValidate = {
        id: { estado: null, mensaje: "", validar: isValue, minmax: false },
        nombre: { estado: true, mensaje: "Valor requerido letras con longitud min 3, max. 45", validar: isLetrasEspacio, minmax: true, min: 3, max: 45 },
        idNivel: { estado: null, mensaje: "", validar: isValue, minmax: false },
        nivel: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
    };

    const [tallerData, setTallerData] = useState(claseTaller);
    const [tallerDataValidate, setTallerDataValidate] = useState(claseTallerValidate);

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.mantenedor.taller.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    const loadListaNivel = async () => {
        if (colegio.id !== undefined) {
            let data = await listaNivel(usuario.token);
            let niv = [];
            niv.push({ id: 0, codigo: "0", nivel: "MÚLTIPLES NIVEL" });
            data.nivel?.forEach((element) => {
                niv.push(element);
            });
            setNiveles(niv);
            setValueNivel({});
        }
    };

    const loadFicha = async () => {
        if (colegio.id !== undefined && anio.anio !== undefined) {
            var data = await getLista(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setDataFicha(data.ficha_estudiantes);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error al obtener los alumnos", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
        }
    };

    const loadCurso = async () => {
        if (colegio.id !== undefined) {
            var data = await listaCurso(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setCursos(data.colegios);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
        }
    };

    const loadListaTaller = async () => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));
            var data = await getListaTalleres(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setTablaData(data.talleres);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        }
    };

    useEffect(() => {
        if (accionPermiso(permisos, "ver")) {
            loadFicha();
            loadCurso();
            loadListaTaller();
            loadListaNivel();
            loadListaProfesor();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    useEffect(() => {
        if (dataFicha !== null) {
            let dataSeleccionMatriculadosSource = [];
            for (let i = 0; i < dataFicha.length; i++) {
                if (valueCurso.idseccion == dataFicha[i].idgrado && valueCurso.idseccion != undefined) {
                    let existe = false;
                    for (let j = 0; j < target.length; j++) {
                        if (target[j].id == dataFicha[i].id) {
                            existe = true;
                            break;
                        }
                    }
                    if (!existe) dataSeleccionMatriculadosSource.push(dataFicha[i]);
                }
            }
            setSource(dataSeleccionMatriculadosSource);
        }
    }, [valueCurso, target]);

    useEffect(() => {
        if (valueNivel.id !== undefined) {
            // loadListaTaller();
        } else {
            // setTablaData([]);
        }
    }, [valueNivel]);

    const nameEditor = (props, field) => {
        return inputTextEditor(props, field);
    };

    const inputTextEditor = (props, field) => {
        return <InputText type="text" style={{ width: "-webkit-fill-available" }} value={props.rowData[field]} onChange={(e) => onEditorValueChange(props, e.target.value)} onBlur={(e) => onCellEditComplete(props, e.target.value)} />;
    };

    const onEditorValueChange = (props, value) => {
        let udpdateTabla = [...tablaData];
        udpdateTabla[props.rowIndex][props.field] = value;
        setTablaData(udpdateTabla);
    };

    const onCellEditComplete = (props, value) => {
        if (value.trim() !== "") {
            let dat = tablaData[props.rowIndex];
            dataEdit.current = dat;
            dataEdit.current.array_profe = getJsonToArray(dat.idsprofesionales);
            dataEdit.current.array_matri = getJsonToArray(dat.idsmatriculas);
            updateTaller(dataEdit.current, false);
        }
    };

    const loadListaProfesor = async () => {
        if (colegio.id !== undefined) {
            let rolesData = await listaProfesores(colegio.id, usuario.token);
            setProfesionales(rolesData.profesores);
        }
    };

    const saveTaller = async () => {
        setSubmitted(true);

        if (colegio.id !== undefined) {
            dispatch(loading(true));

            let validado = getResultValidar(tallerData, tallerDataValidate);

            setTallerDataValidate(validado.result);

            if (validado.registra) {
                var data = await crearTaller(colegio.id, tallerData.nivel.id, tallerData.nombre, usuario.token);

                if (data.error == 0) {
                    loadListaTaller();
                    hideDialog();
                    toast.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
            }
            dispatch(loading(false));
        }
    };

    const updateTaller = async (selectData, es_alumno) => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));

            let taller = {
                id: selectData.id,
                alias: selectData.personalizado,
                profesionales_json: "[]",
                matriculas_json: "[]",
            };

            if (selectData.array_profe.length > 0) {
                let dat = selectData.array_profe?.map((a) => {
                    return { id: a };
                });
                taller.profesionales_json = JSON.stringify(dat);
            }

            if (target.length > 0) {
                let dat = target?.map((a) => {
                    return { id: a.id };
                });
                taller.matriculas_json = JSON.stringify(dat);
            }

            var data = await editarTaller(colegio.id, taller, usuario.token);

            if (data.error == 0) {
                loadListaTaller();
                if (es_alumno) toastBL.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
            } else {
                if (data.error == 1) {
                    toastBL.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        }
    };

    const onInputChangeCurso = (e) => {
        const val = (e.target && e.target.value) || "";
        setValueCurso(val);
    };

    const getJsonToArray = (value) => {
        let ids = value.replaceAll("[", "");
        ids = ids.replaceAll("]", "");
        if (ids.trim() !== "") {
            return ids.split(",").map(Number);
        } else {
            return [];
        }
    };

    const viewProfAlum = (data, tipo) => {
        if (!accionPermiso(permisos, "editar")) {
            toast.current.show({ severity: "warn", summary: "Permisos", detail: "No tiene permisos para asignar Profesionales, consulte con el administrador del sistema", life: 3000 });
            return;
        }

        dataEdit.current = data;
        dataEdit.current.array_profe = getJsonToArray(data.idsprofesionales);
        dataEdit.current.array_matri = getJsonToArray(data.idsmatriculas);

        if (tipo == "p") {
            setVisibleRight(true);
            setSelectedProfesionales(dataEdit.current.array_profe);
        }
        if (tipo == "a") {
            setVisibleRightA(true);

            let arrayIdsNiveles = [];
            let dataSeleccionMatriculadosTarget = [];
            for (let i = 0; i < dataFicha.length; i++) {
                if (dataEdit.current.array_matri.indexOf(dataFicha[i].id) >= 0) {
                    dataSeleccionMatriculadosTarget.push(dataFicha[i]);
                    arrayIdsNiveles.push(dataFicha[i].idnivel);
                }

                if (dataSeleccionMatriculadosTarget.length == dataEdit.current.array_matri.length) {
                    break;
                }
            }

            if (data.idnivel == null) {
                arrayIdsNiveles = arrayIdsNiveles.filter((item, index) => arrayIdsNiveles.indexOf(item) === index);
            } else {
                arrayIdsNiveles.push(data.idnivel);
            }

            setSelectedNiveles(arrayIdsNiveles);
            setFilterCursos(arrayIdsNiveles);
            setSource([]);
            setTarget(dataSeleccionMatriculadosTarget);
        }
    };

    const viewNuevoCurso = () => {
        setVisibleDialog(true);
        labelDialog.current.title = "Nuevo Taller";
        labelDialog.current.labelButton = "Registrar";
        labelDialog.current.es_nuevo = true;
        setTallerData(claseTaller);
    };

    const hideDialog = () => {
        setVisibleDialog(false);
        labelDialog.current.visible = false;
        setSubmitted(false);
        setTallerData(claseTaller);
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...tallerData };
        _detalla[`${name}`] = val;
        setTallerData(_detalla);
    };

    const dataTableHeader = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>

            <div className="flex align-items-center export-buttons">
                {accionPermiso(permisos, "crear") ? <Button type="button" icon="pi pi-plus" label="Taller" className="mr-2 p-mr-1" onClick={viewNuevoCurso} tooltip="Nuevo Taller" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={() => loadListaTaller()} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
            </div>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const bodyTemplateAlias = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field] == "" ? <span style={{ opacity: "40%" }}>::Ingrese Alias::</span> : data[props.field]}
            </>
        );
    };

    const bodyTemplateNumero = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <div className="grid-container">
                    <div>{data[props.field]}</div>
                    <div>
                        <Button className="p-button-rounded p-mr-1" onClick={() => viewProfAlum(data, props.header == "Alumnos" ? "a" : "p")}>
                            {"+" + (props.header == "Alumnos" ? data.total_alumnos : data.total_profesores)}
                        </Button>
                    </div>
                </div>
            </>
        );
    };

    const confirmSave = () => {
        confirmDialog({
            message: "Estas seguro de Registrar?",
            header: "Registrar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-success",
            accept: () => updateTaller(dataEdit.current, true),
        });
    };

    const eliminar = async (row) => {
        let data = await eliminarTaller(colegio.id, row.id, usuario.token);

        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó el Taller", life: 3000 });
            loadListaTaller();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
    };

    const confirmDelete = (row) => {
        confirmDialog({
            message: "Estas seguro de eliminar el Taller?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => eliminar(row),
        });
    };

    const bodyTemplateOpciones = (rowData, props) => {
        return (
            <>
                {" "}
                <span className="p-column-title">{props.header}</span>
                {accionPermiso(permisos, "eliminar") ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDelete(rowData)} /> : ""}
            </>
        );
    };

    const oProfesionalChange = (e) => {
        let _selectedCategories = [...selectedProfesionales];
        let position = _selectedCategories.indexOf(e.value);
        if (e.checked) {
            if (position < 0) _selectedCategories.push(e.value);
        } else {
            if (position >= 0) {
                _selectedCategories.splice(position, 1);
            }
        }
        setSelectedProfesionales(_selectedCategories);
        dataEdit.current.array_profe = _selectedCategories;
        updateTaller(dataEdit.current, false);
    };

    const oNivelChange = (e) => {
        let _selectedNiveles = [...selectedNiveles];
        let position = _selectedNiveles.indexOf(e.value);
        if (e.checked) {
            if (position < 0) _selectedNiveles.push(e.value);
        } else {
            if (position >= 0) {
                _selectedNiveles.splice(position, 1);
            }
        }

        setSelectedNiveles(_selectedNiveles);
        setFilterCursos(_selectedNiveles);
    };

    const setFilterCursos = (niveles) => {
        const cursosFil = cursos.filter((valor, indice) => {
            return niveles.indexOf(valor.idnivel) >= 0;
        });

        setCursosFilter(cursosFil);
        if (cursosFil.length < 1) setValueCurso({});
    };

    // Seleccionar alumnos

    const onChange = (event) => {
        setSource(event.source);
        setTarget(event.target);
    };

    const itemTemplate = (item) => {
        return (
            <div className="product-item">
                <div className="product-list-detail">
                    <div className="p-mb-1" style={{ fontWeight: "bold" }}>
                        {item.apellido_paterno} {item.apellido_materno} {item.nombres}
                    </div>
                    <i className="pi pi-tag product-category-icon"></i>
                    <span className="product-category p-ml-1">
                        {item.nivel} - Seccion: {item.grado}
                    </span>
                </div>
            </div>
        );
    };

    ///////////////////////////

    const dialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={labelDialog.current.labelButton} icon="pi pi-check" onClick={saveTaller} />
        </>
    );

    return (
        <div className="p-grid table-demo">
            <Toast ref={toast} />
            <Toast ref={toastBL} position="bottom-right" />
            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
                <h5>Profesional</h5>
                {profesionales?.map((pro) => {
                    return (
                        <div key={pro.id} className="p-field-checkbox">
                            <Checkbox inputId={pro.id} name="pro" value={pro.id} onChange={oProfesionalChange} checked={selectedProfesionales.indexOf(pro.id) >= 0} />
                            <label htmlFor={pro.id}>{pro.profesional}</label>
                        </div>
                    );
                })}
            </Sidebar>
            <Sidebar
                style={{ width: "80%" }}
                visible={visibleRightA}
                /* className="p-sidebar-lg" */
                position="right"
                showCloseIcon={false}
                dismissable={false}
                onHide={() => setVisibleRightA(false)}
                icons={() => (
                    <React.Fragment>
                        <Button icon="pi pi-save" className="p-button-rounded p-button-success p-mr-2" onClick={() => confirmSave()} />
                        <Button icon="pi pi-arrow-right" className="p-button-rounded p-button-secondary p-button-outlined" onClick={() => setVisibleRightA(false)} />
                    </React.Fragment>
                )}
            >
                <h5>Agregue a los estudiantes en el Taller:</h5>

                <div className="p-grid">
                    <div className="p-col-3">
                        <div className="p-fluid">
                            {niveles?.map((pro) => {
                                if (pro.id == 0) return "";
                                return (
                                    <div key={pro.id} className="p-field-checkbox">
                                        <Checkbox inputId={pro.id} name="pro" disabled={dataEdit.current.idnivel == null ? false : true} value={pro.id} onChange={oNivelChange} checked={selectedNiveles.indexOf(pro.id) >= 0} />
                                        <label htmlFor={pro.id}>{pro.nivel}</label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <Divider layout="vertical"></Divider>

                    <div style={{ width: "72%" }}>
                        <div className="p-col-12 p-md-12 p-lg-4 p-pl-4 p-mb-2 section p-fluid" style={{ textAlign: "right", padding: "0px" }}>
                            <Dropdown value={valueCurso} onChange={(e) => onInputChangeCurso(e)} options={cursosFilter} optionLabel="nombre" placeholder="::Ingrese Curso::" />
                        </div>

                        <PickList source={source} target={target} itemTemplate={itemTemplate} sourceHeader="Alumnos" targetHeader="Seleccionados" sourceStyle={{ height: "500px" }} targetStyle={{ height: "500px" }} onChange={onChange}></PickList>
                    </div>
                </div>
            </Sidebar>
            <DataTable showGridlines
                value={tablaData}
                paginator
                id="13"
                className="p-datatable-customers p-datatable-sm editable-cells-table"
                rowsPerPageOptions={[10, 15, 30]}
                rows={10}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Reg. {first} - {last} de {totalRecords}"
                globalFilter={globalFilter}
                emptyMessage="No existe información!"
                editMode="cell"
                loading={false}
                header={dataTableHeader}
                responsiveLayout="scroll"
                size="small"
            >
                <Column field="nivel" header="Nivel" body={bodyTemplate}></Column>
                <Column field="nombre" header="Nombre Taller" body={bodyTemplate}></Column>
                {accionPermiso(permisos, "editar") ? <Column field="personalizado" header="Nombre Personalizado" classNames="cursor-auto" body={bodyTemplateAlias} editor={(e) => nameEditor(e, "personalizado")}></Column> : <Column field="personalizado" header="Nombre Personalizado"></Column>}

                <Column field="profesionales" header="Profesores" body={bodyTemplateNumero}></Column>
                <Column field="alumnos" header="Alumnos" body={bodyTemplateNumero}></Column>
                <Column headerStyle={{ width: "5rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible" }} field="total" header="Eliminar" body={bodyTemplateOpciones}></Column>
            </DataTable>
            <Dialog visible={visibleDialog} style={{ width: "40vw" }} breakpoints={{ "960px": "100vw" }} header={labelDialog.current.title} modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>
                <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0">
                    <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                        <label htmlFor="name2">Nivel</label>
                        <Dropdown value={tallerData.nivel} onChange={(e) => onInputChange(e, "nivel")} options={niveles} optionLabel="nivel" placeholder="--" />
                        {submitted && !tallerDataValidate.nivel.estado && <small className="p-error">{tallerDataValidate.nivel.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                        <label htmlFor="name2">Taller</label>
                        <InputText value={tallerData.nombre} onChange={(e) => onInputChange(e, "nombre")} required className={classNames({ "p-invalid": submitted && !tallerDataValidate.nombre.estado })} />
                        {submitted && !tallerDataValidate.nombre.estado && <small className="p-error">{tallerDataValidate.nombre.mensaje}</small>}
                    </div>
                </div>
            </Dialog>

        </div>
    );
};
